import { setupTurboRedirect } from "./util/turbo_redirect"
import './src/jquery'
import 'jquery-migrate'  // Load jquery-migrate (configured in jquery.js)

import './src/underscore'
import './src/toastr'

import 'jquery-ui/dist/jquery-ui'  // Using npm package v1.14.1 instead of vendored v1.12.1
import 'jquery-locationpicker'
import 'jquery-validation'
import 'jquery3-bootstrap-switch'  // Replaced bootstrap-switch with jQuery 3 compatible version
import TomSelect from 'tom-select'
window.TomSelect = TomSelect

import "@hotwired/turbo-rails"
import TC from "@rolemodel/turbo-confirm"

// Import Bootstrap 3 components
import './vendor/bootstrap/tooltip'
import './vendor/bootstrap/button'
import './vendor/bootstrap/collapse'
import './vendor/bootstrap/modal'
import './vendor/bootstrap/alert'
import './vendor/bootstrap/dropdown'
import './vendor/bootstrap/tab'

// old js scripts with jquery dependency
import "./old"

import "./controllers"
import "./util/close_modals_before_cache"

document.addEventListener("DOMContentLoaded", () => {
  setupTurboRedirect()
})

// Also initialize on turbo:load for SPA navigation
document.addEventListener("turbo:load", () => {
  TC.start({
    dialogSelector: '#confirm',
    acceptSelector: '#confirm-accept',
    denySelector: '.confirm-cancel',
    activeClass: 'in',
    showConfirmCallback: (element) => {
      $(element).modal('show')
    },
    hideConfirmCallback: (element) => {
      $(element).modal('hide')
    }
  })
})
